import { sbaAxios } from "../utils/sbaAxios";
import { getCrmDocumentTyes } from "../../config/apiConfig";
import {
  FETCH_CRMDOCUMENTTYPES_BEGIN,
  FETCH_CRMDOCUMENTTYPES_SUCCESS,
  FETCH_CRMDOCUMENTTYPES_FAILURE,
  } from '../constants/document';

  export const getCrmDocumentTypesAction = () => {
    return async (dispatch) => {
        dispatch(getCrmDocumentTypesBegin());
        try {
            const response = await
                sbaAxios({
                    url: `${getCrmDocumentTyes}`,
                    method: 'get',
                })
            const crmDocumentTypesData = response;
            dispatch(getCrmDocumentTypesSuccess(crmDocumentTypesData));
        } catch (error) {
            if (error.message === "Network Error") {
                dispatch(getCrmDocumentTypesSuccess({}));
            } else {
                dispatch(getCrmDocumentTypesFailure(error));
            }
        }
    };
};
export const getCrmDocumentTypesBegin = () => ({
  type: FETCH_CRMDOCUMENTTYPES_BEGIN,
});

export const getCrmDocumentTypesSuccess = (crmDocumentTypesData) => ({
  type: FETCH_CRMDOCUMENTTYPES_SUCCESS,
  payload: {crmDocumentTypesData},
});


export const getCrmDocumentTypesFailure = (errorMessage) => ({
  type: FETCH_CRMDOCUMENTTYPES_FAILURE,
  payload: {errorMessage}
});
